/**
 * SINGLE SOURCE OF TRUTH for all RankifyLocal pricing.
 * Both the report pricing section AND the chat assistant read from this.
 * Update prices HERE and they propagate everywhere.
 */

export const FOUNDING_CODE = "FOUNDING35";
export const FOUNDING_DISCOUNT = 0.35; // 35% off

export const PLANS = [
  {
    id: "reputation_essentials",
    name: "Reputation Essentials",
    regularPrice: 97,
    foundingPrice: 63,
    period: "/mo",
    tagline: "Build the review foundation and online credibility local customers expect before they book.",
    trialNote: "7-Day Free Trial",
    features: [
      "20+ review platform integrations",
      "SMS 100/mo + Email 5,000/mo",
      "Smart Review Filter",
      "Automation Suite",
      "Social Sharing",
      "Review Analytics Dashboard",
    ],
    // Stripe coupon FOUNDING35 (35% off, forever) must be created in Stripe Dashboard for this to auto-apply.
    stripeLink: "https://buy.stripe.com/fZu8wRfc97k64hb9Lk0RG00?prefilled_promo_code=FOUNDING35",
    color: "#3B82F6",
    popular: false,
  },
  {
    id: "growth",
    name: "Growth",
    regularPrice: 497,
    foundingPrice: 323,
    period: "/mo",
    tagline: "Everything you need to rank Top 3 on Google Maps, grow reviews, and turn visibility into booked appointments.",
    features: [
      "Everything in Reputation Essentials",
      "Google Maps Ranking Engine (all 8 signals)",
      "SMS 500/mo + Email 10,000/mo + WhatsApp + QR",
      "AI Agent",
      "Bi-Weekly 49-point Geo-Grid Reports",
      "90-Day Top 3 Guarantee (work free until ranked)",
    ],
    stripeLink: "https://buy.stripe.com/eVqeVfd4133Q7tnf5E0RG01?prefilled_promo_code=FOUNDING35",
    color: "#10B981",
    popular: true,
  },
  {
    id: "market_domination",
    name: "Market Domination",
    regularPrice: 997,
    foundingPrice: 648,
    period: "/mo",
    tagline: "The complete system for multi-location and high-competition markets that need to own every keyword and neighbourhood.",
    features: [
      "Everything in Growth",
      "SMS 1,000/mo + Email 20,000/mo",
      "White-Label",
      "AI Review Response Drafting",
      "Live Website Review Widgets",
      "Competitor Grid Monitoring",
      "90-Day Top 3 Guarantee",
    ],
    stripeLink: "https://buy.stripe.com/3cI4gBbZX47UcNH4r00RG02?prefilled_promo_code=FOUNDING35",
    color: "#8B5CF6",
    popular: false,
  },
];

/**
 * Plain-text summary for injection into LLM/chat system prompts.
 * Keeps the chat assistant from hallucinating prices.
 */
export const PRICING_TEXT_FOR_LLM = PLANS.map(p =>
  `${p.name}: regular $${p.regularPrice}/mo, founding member price $${p.foundingPrice}/mo (code ${FOUNDING_CODE}, 35% off locked forever). ${p.tagline} Features: ${p.features.join(", ")}.`
).join("\n");

export function formatPrice(amount) {
  return `$${amount.toLocaleString("en-US")}`;
}
